import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/inventory-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getSummary = (Options = {}) => {
  return httpClient
    .get('/api/v1/summary-inventory-lists', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productCategory = (Options = {}) => {
  return httpClient
    .get('/api/v1/inventory-lists/product-categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const refreshStock = data => {
  return httpClient
    .post('/api/v1/inventory-lists/refresh-stocks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const refreshCurrentStock = data => {
  return httpClient
    .post('/api/v1/inventory-lists/refresh-current-stocks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const refreshDailyStock = data => {
  return httpClient
    .post('/api/v1/inventory-lists/refresh-daily-stocks', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, getSummary, productCategory, refreshStock, refreshCurrentStock, refreshDailyStock }
